/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        color: "text.main",
        typographyProps: {
            size: "12px",
            color: "text.main",
            css: css`
                margin: 0;
                padding-right: 1px;
            `,
        },
        iconProps: {
            src: "X",
            size: 12,
            color: "text.main",
        },
        css: css`
            margin: 2px;
            background: ${getColor("common.ui8")};
            display: flex;
            align-items: center;
            border-radius: 24px;
            padding: 1px 2px 1px 5px;
            min-height: unset;

            button {
                &,
                & &:hover,
                & &:focus {
                    background: transparent !important;
                    padding: 0;
                }
            }
        `,
    },
} as xBaseTheme["tag"];
